import { useEffect } from "react";
import { useThree } from "@react-three/fiber";
function useCursor(hovered, onPointerOver = "pointer") {
	const canvas = useThree((s) => s.gl.domElement);
	useEffect(() => {
		if (hovered) {
			canvas.style.cursor = onPointerOver;
			return () => {
				canvas.style.cursor = "default";
			};
		}
	}, [hovered]);
}
export { useCursor };

//# sourceMappingURL=index211.js.map